import { createSelector } from 'reselect';
export var selectSessionState = function (state) { return state.get('connection'); };
export var selectShowConnectionError = createSelector(selectSessionState, function (sessionState) {
    return !sessionState.get('connectedAPI') || !sessionState.get('connectedWeb');
});
